import { FormControl, TextField } from "@mui/material";

const BankDetailsFields = ({ formData, handleFormDataChange }) => {
    const ifscValue = formData.ifsc_code || "";
    const isIfscInvalid = ifscValue !== "" && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifscValue);

    return (
        <div className="row">
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Project Name *"
                        name="project_name"
                        value={formData.project_name || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ maxLength: 50 }}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Beneficiary Name *"
                        name="beneficiary_name"
                        value={formData.beneficiary_name || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ maxLength: 50 }}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Bank Name *"
                        name="bank_name"
                        value={formData.bank_name || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ maxLength: 50 }}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Branch Name *"
                        name="branch_name"
                        value={formData.branch_name || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ maxLength: 50 }}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Account No *"
                        name="account_no"
                        value={formData.account_no || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ inputMode: "numeric", maxLength: 30 }}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="IFSC Code *"
                        name="ifsc_code"
                        value={formData.ifsc_code || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ maxLength: 11 }}
                        error={isIfscInvalid}
                        helperText={isIfscInvalid ? "Please enter a valid IFSC Code (e.g., SBIN0001234)." : ""}
                    />
                </FormControl>
            </div>
        </div>
    );
};

export default BankDetailsFields;